
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34276',
  depVersions: {
  "documents-public-ui": "static-1.34276",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34281",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2039",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5504",
  "hs-test-utils": "static-1.7922",
  "hub-http": "static-1.6129",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11367",
  "I18n": "static-7.1604",
  "jasmine-immutable": "static-1.2927",
  "jasmine-runner": "static-1.6377",
  "lodash": "static-1.3",
  "quartz": "static-1.6883",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16567",
  "reporting-data": "static-1.67090",
  "reporting-testing-lib": "static-1.9023",
  "reporting-visualizations": "static-1.59166",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4678",
  "webpack-env": "static-1.54",
  "atom": "static-1.4980",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2403",
  "classnames": "static-2.10",
  "cssUtils": "static-1.771",
  "customer-data-filters-ui": "static-1.39400",
  "customer-data-objects": "static-1.7569",
  "customer-data-property-utils": "static-1.7994",
  "data-fetching-client": "static-1.9584",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4439",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85594",
  "FormUrlGenerator": "static-2.4628",
  "foundations-components": "static-1.7747",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11675",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7068",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3761",
  "property-translator": "static-1.5316",
  "quartz-config": "static-1.661",
  "quartz-core": "static-1.6102",
  "quick-fetch": "static-1.3843",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5275",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8077",
  "reference-resolvers-lite": "static-1.8000",
  "report-customization-components": "static-1.12862",
  "reporting-enablement": "static-1.22547",
  "reporting-reports": "static-1.66768",
  "reporting-snowflake": "static-1.55708",
  "reporting-ui-components": "static-2.64361",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4553",
  "sales-content-partitioning": "static-1.8846",
  "SalesContentIndexUI": "static-3.9103",
  "sanitize": "static-1.4382",
  "sanitize-text": "static-1.8054",
  "self-service-api": "static-1.10154",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1659",
  "signup-constants": "static-1.18686",
  "signup-ui-lego-core": "static-1.20696",
  "signup-ui-url-generator": "static-2.7943",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4678",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10900",
  "ui-addon-i18n": "static-1.11058",
  "ui-addon-react-router-dom": "static-1.9454",
  "ui-addon-upgrades": "static-9.17857",
  "ui-asset-management-lib": "static-1.10898",
  "ui-images": "static-2.1131",
  "UIComponents": "static-3.8314",
  "usage-tracker": "static-1.7245",
  "usage-tracker-container": "static-1.7235",
  "usage-tracker-core": "static-1.7095",
  "usage-tracker-public": "static-1.7056",
  "viral-links-lib": "static-1.6956",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3334",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3160",
  "quartz-webpack": "static-1.3107",
  "ai-components-ui-library": "static-1.8709",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4760",
  "foundations-theming": "static-1.4323",
  "quartz-auth": "static-1.558",
  "ui-business-units-lib": "static-1.8950",
  "usage-tracker-session-replay": "static-1.4931",
  "foundations-theming-base": "static-1.3308",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3033",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.16",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4233",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7833",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3517",
  "persist-promise": "static-1.3619",
  "quartz-i18n": "static-1.558",
  "reporting-client-types": "static-1.2430",
  "foundations-components-legacy": "static-1.772",
  "hs-story-utils": "static-1.9339",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9755",
  "hubspotter-http": "static-1.4579",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7160",
  "crm-message-bus": "static-1.42726",
  "customer-data-filters-ui-msw-helpers": "static-1.21835",
  "customer-data-objects-ui-components": "static-1.12930",
  "customer-data-reference-ui-components": "static-1.13065",
  "customer-data-ui-utilities": "static-1.9735",
  "framework-builder-read-service-client": "static-1.3936",
  "framework-data-schema-quick-fetch": "static-1.6689",
  "framework-data-schema-resolvers": "static-1.6784",
  "inbound-db-properties-service-client": "static-1.3773",
  "multi-account-reference-resolvers": "static-1.885",
  "onboarding-tours": "static-1.16437",
  "reporting-datasets-permissions-lib": "static-1.13409",
  "ui-addon-teams": "static-1.21426",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68075",
  "customer-data-properties": "static-1.51223",
  "forms-ai-lib": "static-1.4177",
  "forms-utils-lib": "static-1.12410",
  "foundations-components-test-utils": "static-1.5230",
  "react-dnd-compat": "static-1.4528",
  "react-tinymce": "static-1.54978",
  "tinymce-config": "static-2.54104",
  "ui-gdpr-components": "static-1.10257",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4016",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1561",
  "ui-fonts": "static-1.629",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.548",
  "quartz-routing": "static-1.313",
  "quartz-test": "static-1.558",
  "quartz-tracking": "static-1.262",
  "batch-promise": "static-1.1462",
  "external-options-client-types": "static-1.4085",
  "react-colorpicker": "static-2.10118",
  "copilot-toolkit": "static-1.10874",
  "data-quality-ui-library": "static-1.12637",
  "html-to-image": "static-1.52",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6374",
  "reporting-action-components": "static-1.41013",
  "reporting-insights-lib": "static-1.1443",
  "reporting-plugins": "static-1.10151",
  "ui-addon-draggable-compat": "static-2.4164",
  "ui-addon-opt": "static-4.8291",
  "ui-shepherd-react": "static-3.10057",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25088",
  "hubspot-apollo-client": "static-1.4787",
  "chirp-fetch": "static-1.1791",
  "sales-templates-service-types-lib": "static-1.4095",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5707",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4005",
  "nested-table": "static-1.134",
  "timezone-utils": "static-2.5153",
  "bender-build-tools": "static-1.3063",
  "chatspot-core": "static-1.20865",
  "bend-plugin-foundations-theming": "static-1.2806",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9753",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3724",
  "crm-pipelines-api-client-types": "static-1.4069",
  "multi-currency-client-types": "static-1.3618",
  "getting-started-shared-tasks": "static-1.18236",
  "growth-data-modal": "static-1.5290",
  "growth-onboarding-confetti": "static-1.2980",
  "growth-onboarding-next-action-utils": "static-1.1643",
  "navigation-components": "static-1.17695",
  "onboarding-tours-client": "static-1.4651",
  "onboarding-tours-utils": "static-1.503",
  "ui-shepherd-tracker": "static-1.7438",
  "ui-universal-auth": "static-1.8852",
  "user-context": "static-1.5010",
  "cms-field-types": "static-1.4719",
  "content-icons-ui": "static-1.2204",
  "integrations-lib": "static-1.15818",
  "calling-global-api": "static-1.64140",
  "calling-internal-common": "static-1.31211",
  "calling-lifecycle-internal": "static-1.65522",
  "calling-lifecycle-messages": "static-1.57816",
  "commerce-products-lib": "static-1.9194",
  "crm-links": "static-1.6187",
  "customer-data-properties-shared-msw-handlers": "static-1.9082",
  "file-manager-components": "static-1.23333",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.50",
  "inbounddb-objects-service-types": "static-1.4150",
  "meetings-icalendar-utils-lib": "static-1.539",
  "object-builder-ui-client": "static-1.48426",
  "pipeline-validation-client-types": "static-1.3893",
  "property-value-citations": "static-1.1837",
  "pulse": "static-1.455",
  "smart-property-lib": "static-1.6482",
  "tiered-pricing": "static-1.1029",
  "ui-addon-iframeable": "static-1.8960",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19674",
  "tinymce-themes": "static-1.56074",
  "data-token-picker": "static-1.16245",
  "hub-http-contrib": "static-1.2952",
  "interframe": "static-3.4672",
  "tinymce-data": "static-1.40189",
  "tinymce-plugins": "static-1.57218",
  "ui-addon-sales-email": "static-1.5121",
  "magpie-lib": "static-1.5504",
  "magpie-types": "static-1.4964",
  "simple-logging-lib": "static-1.2961",
  "content-assistance-lib": "static-1.7619",
  "dashboard-lib": "static-1.81147",
  "ExportDialog": "static-6.10299",
  "hubspot-prosemirror": "static-1.17969",
  "hubspot-prosemirror-plugins": "static-1.17961",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8605",
  "campaign-roi-lib": "static-1.8686",
  "feedback-loader": "static-1.29128",
  "apollo-link-hub-http": "static-2.4560",
  "hubspot-apollo-cache": "static-1.246",
  "nav-client-types": "static-1.2267",
  "purchase-motions-api": "static-1.5710",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.82",
  "onboarding-data-sync-lib": "static-1.1809",
  "growth-onboarding-next-action-components": "static-1.1671",
  "user-context-client": "static-1.4521",
  "idb-keyval": "static-1.42",
  "nest": "static-1.133",
  "reactive-lib": "static-1.633",
  "unified-auth-core-lib": "static-1.647",
  "getting-started-shared-tasks-store": "static-1.17354",
  "integrations-error-boundary-lib": "static-1.13233",
  "integrations-tracking-lib": "static-1.5506",
  "native-integrations-shared-strings": "static-1.7695",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10283",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.366",
  "calling-error-reporting": "static-1.31217",
  "shared-worker-versioning": "static-1.10947",
  "calling-usage-tracker": "static-1.6450",
  "voice-sms-access-library": "static-1.631",
  "customer-data-tracking": "static-1.6794",
  "commerce-permissions": "static-1.675",
  "products-iframe-lib": "static-1.7669",
  "products-ui-components-shared-msw-handlers": "static-1.10137",
  "location-customization-utils-lib": "static-1.8952",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4062",
  "video-components-external": "static-1.10978",
  "video-data-lib": "static-1.34636",
  "directed-graph": "static-1.847",
  "event-emitter": "static-1.857",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.53",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9838",
  "fsm": "static-1.3644",
  "policy-lib": "static-1.6693",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9901",
  "navigation-messaging": "static-1.7022",
  "FileManagerLib": "static-1.38973",
  "NamespacedHubStyle": "static-2.8994",
  "FileManagerCore": "static-1.38832",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12269",
  "layout-dnd-utils": "static-1.11244",
  "react-codemirror": "static-1.10533",
  "ui-addon-emoji-picker": "static-1.9796",
  "ui-brand-identity-lib": "static-1.14836",
  "ui-addon-video-player": "static-1.8606",
  "ui-coaching-tips": "static-1.28283",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8455",
  "payment-link-components": "static-1.23272",
  "EmailSignatureEditor": "static-1.24175",
  "InboxConnectUtils": "static-4.14554",
  "universal-page-editor-lib": "static-1.2918",
  "microsoft-drive-integration-lib": "static-1.50",
  "calling-orchestration-schema": "static-1.35408",
  "sales-views-client-types": "static-1.4172",
  "crm-record-cards-service-types": "static-1.3537",
  "content-media-composition-data-lib": "static-1.11962",
  "content-media-compositions": "static-2.15969",
  "media-bridge-lib": "static-1.18766",
  "trellis-story-utils": "static-1.4427",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5781",
  "FileManagerImages": "static-1.36484",
  "video-components": "static-1.12981",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4441",
  "video-embed": "static-1.35470",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68150",
  "layout-data-lib": "static-1.9569",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6491",
  "commerce-tours-lib": "static-1.5930",
  "growth-onboarding-reliability": "static-1.4994",
  "sales-checkout-service-client": "static-1.3569",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21514",
  "sales-email-signature-service-client": "static-1.3752",
  "social-insights-client-types": "static-1.21824",
  "outpost": "static-1.4102",
  "advanced-menus-core": "static-1.14991",
  "advanced-menus-lib": "static-1.11948",
  "ui-memberships-settings-lib": "static-1.33788",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14990",
  "simple-menus-lib": "static-1.16507"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34276",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34281",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2039",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5504",
  "hs-test-utils": "/hs-test-utils/static-1.7922",
  "hub-http": "/hub-http/static-1.6129",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11367",
  "I18n": "/I18n/static-7.1604",
  "jasmine-immutable": "/jasmine-immutable/static-1.2927",
  "jasmine-runner": "/jasmine-runner/static-1.6377",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6883",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16567",
  "reporting-data": "/reporting-data/static-1.67090",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9023",
  "reporting-visualizations": "/reporting-visualizations/static-1.59166",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4678",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4980",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2403",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.771",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39400",
  "customer-data-objects": "/customer-data-objects/static-1.7569",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7994",
  "data-fetching-client": "/data-fetching-client/static-1.9584",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4439",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85594",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4628",
  "foundations-components": "/foundations-components/static-1.7747",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11675",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7068",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3761",
  "property-translator": "/property-translator/static-1.5316",
  "quartz-config": "/quartz-config/static-1.661",
  "quartz-core": "/quartz-core/static-1.6102",
  "quick-fetch": "/quick-fetch/static-1.3843",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5275",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8077",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8000",
  "report-customization-components": "/report-customization-components/static-1.12862",
  "reporting-enablement": "/reporting-enablement/static-1.22547",
  "reporting-reports": "/reporting-reports/static-1.66768",
  "reporting-snowflake": "/reporting-snowflake/static-1.55708",
  "reporting-ui-components": "/reporting-ui-components/static-2.64361",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4553",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8846",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9103",
  "sanitize": "/sanitize/static-1.4382",
  "sanitize-text": "/sanitize-text/static-1.8054",
  "self-service-api": "/self-service-api/static-1.10154",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1659",
  "signup-constants": "/signup-constants/static-1.18686",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20696",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7943",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4678",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10900",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11058",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9454",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17857",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10898",
  "ui-images": "/ui-images/static-2.1131",
  "UIComponents": "/UIComponents/static-3.8314",
  "usage-tracker": "/usage-tracker/static-1.7245",
  "usage-tracker-container": "/usage-tracker-container/static-1.7235",
  "usage-tracker-core": "/usage-tracker-core/static-1.7095",
  "usage-tracker-public": "/usage-tracker-public/static-1.7056",
  "viral-links-lib": "/viral-links-lib/static-1.6956",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3334",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3160",
  "quartz-webpack": "/quartz-webpack/static-1.3107",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8709",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4760",
  "foundations-theming": "/foundations-theming/static-1.4323",
  "quartz-auth": "/quartz-auth/static-1.558",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8950",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4931",
  "foundations-theming-base": "/foundations-theming-base/static-1.3308",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3033",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.16",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4233",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7833",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3517",
  "persist-promise": "/persist-promise/static-1.3619",
  "quartz-i18n": "/quartz-i18n/static-1.558",
  "reporting-client-types": "/reporting-client-types/static-1.2430",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.772",
  "hs-story-utils": "/hs-story-utils/static-1.9339",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9755",
  "hubspotter-http": "/hubspotter-http/static-1.4579",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7160",
  "crm-message-bus": "/crm-message-bus/static-1.42726",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21835",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12930",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13065",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9735",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3936",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6689",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6784",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3773",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.885",
  "onboarding-tours": "/onboarding-tours/static-1.16437",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13409",
  "ui-addon-teams": "/ui-addon-teams/static-1.21426",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68075",
  "customer-data-properties": "/customer-data-properties/static-1.51223",
  "forms-ai-lib": "/forms-ai-lib/static-1.4177",
  "forms-utils-lib": "/forms-utils-lib/static-1.12410",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5230",
  "react-dnd-compat": "/react-dnd-compat/static-1.4528",
  "react-tinymce": "/react-tinymce/static-1.54978",
  "tinymce-config": "/tinymce-config/static-2.54104",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10257",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4016",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1561",
  "ui-fonts": "/ui-fonts/static-1.629",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.548",
  "quartz-routing": "/quartz-routing/static-1.313",
  "quartz-test": "/quartz-test/static-1.558",
  "quartz-tracking": "/quartz-tracking/static-1.262",
  "batch-promise": "/batch-promise/static-1.1462",
  "external-options-client-types": "/external-options-client-types/static-1.4085",
  "react-colorpicker": "/react-colorpicker/static-2.10118",
  "copilot-toolkit": "/copilot-toolkit/static-1.10874",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12637",
  "html-to-image": "/html-to-image/static-1.52",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6374",
  "reporting-action-components": "/reporting-action-components/static-1.41013",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1443",
  "reporting-plugins": "/reporting-plugins/static-1.10151",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4164",
  "ui-addon-opt": "/ui-addon-opt/static-4.8291",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10057",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25088",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4787",
  "chirp-fetch": "/chirp-fetch/static-1.1791",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4095",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5707",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4005",
  "nested-table": "/nested-table/static-1.134",
  "timezone-utils": "/timezone-utils/static-2.5153",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chatspot-core": "/chatspot-core/static-1.20865",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2806",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9753",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3724",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4069",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3618",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18236",
  "growth-data-modal": "/growth-data-modal/static-1.5290",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2980",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1643",
  "navigation-components": "/navigation-components/static-1.17695",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4651",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.503",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7438",
  "ui-universal-auth": "/ui-universal-auth/static-1.8852",
  "user-context": "/user-context/static-1.5010",
  "cms-field-types": "/cms-field-types/static-1.4719",
  "content-icons-ui": "/content-icons-ui/static-1.2204",
  "integrations-lib": "/integrations-lib/static-1.15818",
  "calling-global-api": "/calling-global-api/static-1.64140",
  "calling-internal-common": "/calling-internal-common/static-1.31211",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65522",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57816",
  "commerce-products-lib": "/commerce-products-lib/static-1.9194",
  "crm-links": "/crm-links/static-1.6187",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9082",
  "file-manager-components": "/file-manager-components/static-1.23333",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.50",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4150",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.539",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48426",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3893",
  "property-value-citations": "/property-value-citations/static-1.1837",
  "pulse": "/pulse/static-1.455",
  "smart-property-lib": "/smart-property-lib/static-1.6482",
  "tiered-pricing": "/tiered-pricing/static-1.1029",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8960",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19674",
  "tinymce-themes": "/tinymce-themes/static-1.56074",
  "data-token-picker": "/data-token-picker/static-1.16245",
  "hub-http-contrib": "/hub-http-contrib/static-1.2952",
  "interframe": "/interframe/static-3.4672",
  "tinymce-data": "/tinymce-data/static-1.40189",
  "tinymce-plugins": "/tinymce-plugins/static-1.57218",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5121",
  "magpie-lib": "/magpie-lib/static-1.5504",
  "magpie-types": "/magpie-types/static-1.4964",
  "simple-logging-lib": "/simple-logging-lib/static-1.2961",
  "content-assistance-lib": "/content-assistance-lib/static-1.7619",
  "dashboard-lib": "/dashboard-lib/static-1.81147",
  "ExportDialog": "/ExportDialog/static-6.10299",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17969",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17961",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8605",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8686",
  "feedback-loader": "/feedback-loader/static-1.29128",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4560",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.246",
  "nav-client-types": "/nav-client-types/static-1.2267",
  "purchase-motions-api": "/purchase-motions-api/static-1.5710",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.82",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1809",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1671",
  "user-context-client": "/user-context-client/static-1.4521",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.133",
  "reactive-lib": "/reactive-lib/static-1.633",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.647",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17354",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13233",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5506",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7695",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10283",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.366",
  "calling-error-reporting": "/calling-error-reporting/static-1.31217",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10947",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6450",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.631",
  "customer-data-tracking": "/customer-data-tracking/static-1.6794",
  "commerce-permissions": "/commerce-permissions/static-1.675",
  "products-iframe-lib": "/products-iframe-lib/static-1.7669",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10137",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8952",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4062",
  "video-components-external": "/video-components-external/static-1.10978",
  "video-data-lib": "/video-data-lib/static-1.34636",
  "directed-graph": "/directed-graph/static-1.847",
  "event-emitter": "/event-emitter/static-1.857",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.53",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9838",
  "fsm": "/fsm/static-1.3644",
  "policy-lib": "/policy-lib/static-1.6693",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9901",
  "navigation-messaging": "/navigation-messaging/static-1.7022",
  "FileManagerLib": "/FileManagerLib/static-1.38973",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8994",
  "FileManagerCore": "/FileManagerCore/static-1.38832",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12269",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11244",
  "react-codemirror": "/react-codemirror/static-1.10533",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9796",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14836",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8606",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28283",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8455",
  "payment-link-components": "/payment-link-components/static-1.23272",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24175",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14554",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2918",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.50",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35408",
  "sales-views-client-types": "/sales-views-client-types/static-1.4172",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3537",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11962",
  "content-media-compositions": "/content-media-compositions/static-2.15969",
  "media-bridge-lib": "/media-bridge-lib/static-1.18766",
  "trellis-story-utils": "/trellis-story-utils/static-1.4427",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5781",
  "FileManagerImages": "/FileManagerImages/static-1.36484",
  "video-components": "/video-components/static-1.12981",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4441",
  "video-embed": "/video-embed/static-1.35470",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68150",
  "layout-data-lib": "/layout-data-lib/static-1.9569",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6491",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5930",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4994",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21514",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3752",
  "social-insights-client-types": "/social-insights-client-types/static-1.21824",
  "outpost": "/outpost/static-1.4102",
  "advanced-menus-core": "/advanced-menus-core/static-1.14991",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11948",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33788",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14990",
  "simple-menus-lib": "/simple-menus-lib/static-1.16507"
}
};
